import { Component, inject } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { AsyncPipe, NgIf } from '@angular/common';
import { Observable, map, filter, startWith } from 'rxjs';
import { SidebarComponent } from './components/layout/sidebar/sidebar.component';
import { TopbarComponent } from './components/layout/topbar/topbar.component';
import { TermsPromptComponent } from './components/terms/terms-prompt/terms-prompt.component';

const PAGES_WITHOUT_LAYOUT = ['/callback', '/login', '/onboarding', '/terms'];

function hasAppLayout(url: string): boolean {
  return url !== '/' && !PAGES_WITHOUT_LAYOUT.some((page) => url.includes(page));
}

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    SidebarComponent,
    TopbarComponent,
    TermsPromptComponent,
    AsyncPipe,
    NgIf,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: true,
})
export class AppComponent {
  title = 'Fleet Admin';

  private router = inject(Router);

  // Show layout for main app pages (not auth pages, the landing page or the
  // public Terms and Conditions)
  showLayout$: Observable<boolean> = this.router.events.pipe(
    filter((event): event is NavigationEnd => event instanceof NavigationEnd),
    map((event: NavigationEnd) => hasAppLayout(event.url)),
    startWith(hasAppLayout(window.location.pathname))
  );

  // Hide sidebar during onboarding
  showSidebar$: Observable<boolean> = this.router.events.pipe(
    filter((event): event is NavigationEnd => event instanceof NavigationEnd),
    map((event: NavigationEnd) => !event.url.includes('/onboarding')),
    startWith(!window.location.pathname.includes('/onboarding'))
  );
}
